import { render, staticRenderFns } from "./PlatformProjects.vue?vue&type=template&id=62528523&"
import script from "./PlatformProjects.vue?vue&type=script&lang=js&"
export * from "./PlatformProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports